"use strict";

var _toConsumableArray = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activateBrand = exports.fetchInvitationBrand = exports.acceptGuestBrandInvitation = exports.acceptBrandInvitation = exports.fetchBrandInvitation = void 0;

var api_1 = require("../../api");

var actions_1 = require("./actions");

var model_1 = require("./model");

var user_1 = require("../user");

var fetchBrandInvitation = function fetchBrandInvitation(token) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var invitation;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, api_1.apiRequest)('GET', "/brand-invitations/".concat(token));

            case 3:
              invitation = _context.sent;
              dispatch((0, actions_1.setBrandInvitation)(invitation));
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));
  };
};

exports.fetchBrandInvitation = fetchBrandInvitation;

var acceptBrandInvitation = function acceptBrandInvitation(token, account) {
  return function () {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, api_1.apiRequest)('PATCH', "/brand-invitations/".concat(token), account);

            case 3:
              _context2.next = 8;
              break;

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 5]]);
    }));
  };
};

exports.acceptBrandInvitation = acceptBrandInvitation;

var acceptGuestBrandInvitation = function acceptGuestBrandInvitation(token) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return (0, api_1.apiRequest)('PATCH', "/brands/".concat(token, "/invites"));

            case 3:
              dispatch((0, actions_1.setBrandInvitationNotificationState)(model_1.BrandInvitationNotificationState.ACCEPTED));

              if (!getState().authState.shouldShowArchitectFirstConnectionPopup) {
                dispatch((0, actions_1.setDisplayBrandInviteNotification)(true));
              }

              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);

              if (_context3.t0.status && _context3.t0.status === 409) {
                dispatch((0, actions_1.setBrandInvitationNotificationState)(model_1.BrandInvitationNotificationState.ALREADY_ACCEPTED));
                dispatch((0, actions_1.setDisplayBrandInviteNotification)(true));
              } else {
                dispatch((0, actions_1.setBrandInvitationNotificationState)(model_1.BrandInvitationNotificationState.ERROR));
                dispatch((0, actions_1.setDisplayBrandInviteNotification)(true));
              }

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));
  };
};

exports.acceptGuestBrandInvitation = acceptGuestBrandInvitation;

var fetchInvitationBrand = function fetchInvitationBrand(token) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      var brand;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return (0, api_1.apiRequest)('GET', "/brands/invitation-token/".concat(token));

            case 3:
              brand = _context4.sent;
              dispatch((0, actions_1.setInvitationBrand)(brand));
              return _context4.abrupt("return", brand);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              console.error(_context4.t0);
              return _context4.abrupt("return", null);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 8]]);
    }));
  };
};

exports.fetchInvitationBrand = fetchInvitationBrand;

var activateBrand = function activateBrand(brandId) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      var brand, user;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return (0, api_1.apiRequest)('POST', "/brands/".concat(brandId, "/access-request"));

            case 3:
              brand = getState().brandState.values.find(function (brand) {
                return brand.id === brandId;
              });

              if (!(brand == null)) {
                _context5.next = 8;
                break;
              }

              _context5.next = 7;
              return (0, api_1.apiRequest)('GET', "/brands/".concat(brandId));

            case 7:
              brand = _context5.sent;

            case 8:
              dispatch((0, actions_1.setInvitationBrand)(brand));
              user = getState().userState.user;
              dispatch((0, user_1.setUser)(Object.assign(Object.assign({}, user), {
                brands: [].concat(_toConsumableArray(user.brands), [brand])
              })));
              dispatch((0, actions_1.setBrandInvitationNotificationState)(model_1.BrandInvitationNotificationState.ACCEPTED));
              dispatch((0, actions_1.setDisplayBrandInviteNotification)(true));
              _context5.next = 18;
              break;

            case 15:
              _context5.prev = 15;
              _context5.t0 = _context5["catch"](0);

              if (_context5.t0.status === 409) {
                dispatch((0, actions_1.setBrandInvitationNotificationState)(model_1.BrandInvitationNotificationState.ALREADY_ACCEPTED));
                dispatch((0, actions_1.setDisplayBrandInviteNotification)(true));
              } else {
                dispatch((0, actions_1.setBrandInvitationNotificationState)(model_1.BrandInvitationNotificationState.ERROR));
                dispatch((0, actions_1.setDisplayBrandInviteNotification)(true));
              }

            case 18:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 15]]);
    }));
  };
};

exports.activateBrand = activateBrand;